// Frames only: keep full-page navigation on jQuery UJS; use <turbo-frame> for partial updates.
import * as Turbo from "@hotwired/turbo";

Turbo.session.drive = false;
